import React, {
  memo,
  useRef,
} from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DeleteIcon from 'public/img/sell-your-car/icons/bi_trash.svg'
import Draggable from 'components/shared/Draggable'
import sx from './styles'
import FilterItemButton from '../FilterItemButton'

const FiltersSelected = ({
  items,
  onDeleteItem,
  onDeleteAllFilters,
}) => {
  const dragRef = useRef(null)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    items.length > 0 && (
      <Grid>
        {
          (items.length > 0 && isMobile) && (
            <Box
              sx={sx.buttonVariant}
              onClick={() => onDeleteAllFilters()}
            >
              <DeleteIcon />
            </Box>
          )
        }

        {
          !isMobile && (
            <Draggable innerRef={dragRef}>
              <Grid
                size={12}
                sx={sx.filtercontainer}
              >
                {
                  items.length > 0 && (
                    <Box
                      mr={0.5}
                    >
                      <Button
                        variant="outlined"
                        sx={sx.button}
                        onClick={() => onDeleteAllFilters()}
                      >
                        <DeleteIcon />
                      </Button>
                    </Box>
                  )
                }
                {items.map((item) => (
                  <FilterItemButton
                    key={item}
                    item={item}
                    onDeleteItem={onDeleteItem}
                  />
                ))}
              </Grid>
            </Draggable>
          )
        }
      </Grid>
    )
  )
}

export default memo(FiltersSelected)
